//* Menu toggle for the animated background video.
//*
//* The preference lives in a parent-domain "background_video" cookie
//* ("off"; absent = on) so every subdomain (www, events) shares it.
//* The background-video controller listens for the dispatched event
//* to start or stop playback.
import ApplicationController from "application_controller.js";

const COOKIE_KEY = "background_video";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export default class extends ApplicationController {

  debug = false;

  static targets = ["button", "onState", "offState"];

  connect() {
    this.log_function("connect");

    this.sync();
  }

  toggle() {
    this.log_function("toggle");

    if (this.enabled) {
      this.writeCookie("off", COOKIE_MAX_AGE);
    } else {
      this.writeCookie("", 0);
    }

    window.dispatchEvent(new CustomEvent("background-video:toggle"));
    this.sync();
  }

  //* Mirrors the stored preference in the button state text and aria-pressed
  sync() {
    this.log_function("sync");

    this.buttonTarget.setAttribute("aria-pressed", this.enabled);
    this.onStateTargets.forEach((element) => element.classList.toggle("d-none", !this.enabled));
    this.offStateTargets.forEach((element) => element.classList.toggle("d-none", this.enabled));
  }

  writeCookie(value, maxAge) {
    document.cookie = `${COOKIE_KEY}=${value}; domain=.${this.cookieDomain}; path=/; max-age=${maxAge}; samesite=lax`;
  }

  //* The registrable domain (lvh.me in development, go-thassos.gr in production).
  get cookieDomain() {
    return location.hostname.split(".").slice(-2).join(".");
  }

  get enabled() {
    return !(/(?:^|;\s*)background_video=off(?:;|$)/.test(document.cookie));
  }
}
